export interface FeatureExtractionEligibilityInput {
  isExperimentEnabled: boolean;
  projectId: string | undefined;
  visiblePointCloudCount: number;
}

export function isFeatureExtractionEditingEligible(
  input: FeatureExtractionEligibilityInput
): boolean {
  return (
    input.isExperimentEnabled &&
    input.projectId !== undefined &&
    input.visiblePointCloudCount > 0
  );
}

export function isFeatureExtractionPaneEligible(
  editingEligible: boolean,
  viewModeType: string | undefined
): boolean {
  return editingEligible && viewModeType === '3D';
}
